import { WIDGET_COLORS } from '../constants/colors';
import { formatPoints } from '../utils/formatSavingsPoints';

type Props = {
  basePoints: string;
  bonusPoints: string;
  referralPoints: string;
  disabled?: boolean;
};

export function PointsBreakdownLegend({
  basePoints,
  bonusPoints,
  referralPoints,
  disabled = false,
}: Props) {
  const hasBonus = parseFloat(bonusPoints) > 0;
  const hasReferral = parseFloat(referralPoints) > 0;

  if (disabled) {
    return (
      <div className="flex flex-wrap gap-1.5 mt-[-8px] mb-4 items-center">
        <LegendPill
          dotColor={WIDGET_COLORS.gray.bar}
          pillBg={WIDGET_COLORS.gray.legendBg}
          textColor={WIDGET_COLORS.gray.text}
          label={`Community: ${formatPoints(basePoints)} pts`}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1.5 mt-[-8px] mb-4 items-center">
      <LegendPill
        dotColor={WIDGET_COLORS.dustBlue}
        pillBg={WIDGET_COLORS.community.pillBg}
        textColor={WIDGET_COLORS.community.pillText}
        label={`Community: ${formatPoints(basePoints)} pts`}
      />
      {hasBonus && (
        <LegendPill
          dotColor={WIDGET_COLORS.bonus.bar}
          pillBg={WIDGET_COLORS.bonus.pillBg}
          textColor={WIDGET_COLORS.bonus.pillText}
          label={`Bonus: ${formatPoints(bonusPoints)} pts`}
        />
      )}
      {hasReferral && (
        <LegendPill
          dotColor={WIDGET_COLORS.referral.bar}
          pillBg={WIDGET_COLORS.referral.pillBg}
          textColor={WIDGET_COLORS.referral.pillText}
          label={`Referral: ${formatPoints(referralPoints)} pts`}
        />
      )}
    </div>
  );
}

type LegendPillProps = {
  dotColor: string;
  pillBg: string;
  textColor: string;
  label: string;
};

function LegendPill({ dotColor, pillBg, textColor, label }: LegendPillProps) {
  return (
    <span
      className="inline-flex items-center gap-[5px] rounded-full text-[11px] font-semibold"
      style={{ backgroundColor: pillBg, color: textColor, padding: '2px 9px 2px 6px' }}
    >
      <span
        className="w-[7px] h-[7px] rounded-full flex-shrink-0"
        style={{ backgroundColor: dotColor }}
      />
      {label}
    </span>
  );
}
